var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDonHang = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5714C0 12.7919 12.7919 0 28.5714 0H71.4286C87.2081 0 100 12.7919 100 28.5714V71.4286C100 87.2081 87.2081 100 71.4286 100H28.5714C12.7919 100 0 87.2081 0 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_839)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_449_839)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_449_839",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 17,
    width: 66,
    height: 66
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8572 17.8572H82.1429V82.1429H17.8572V17.8572Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_449_839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.9554 31.2499C39.9554 30.1404 39.056 29.241 37.9465 29.241C36.8369 29.241 35.9375 30.1404 35.9375 31.2499V31.9418C33.6253 32.4853 31.9197 34.5216 31.9197 36.9473C31.9197 39.5374 33.7938 41.864 36.3031 42.3519L38.823 42.8419C39.5209 42.9776 39.9554 43.5508 39.9554 44.1405C39.9554 44.6361 39.5893 45.2902 38.9863 45.4075C38.3331 45.5344 37.6586 45.5186 37.0128 45.3617C36.4401 45.2227 35.9926 44.9331 35.7151 44.3936C35.2077 43.4069 33.9965 43.0184 33.0098 43.5259C31.9538 44.069 31.6769 45.3266 32.1965 46.3369C32.9529 47.8078 34.3393 48.8468 35.9375 49.2352V49.9999C35.9375 51.1094 36.8369 52.0088 37.9465 52.0088C39.056 52.0088 39.9554 51.1094 39.9554 49.9999V49.308C42.2676 48.7645 43.9732 46.7283 43.9732 44.3025C43.9732 41.7124 42.0991 39.3858 39.5899 38.8979L37.0699 38.4079C36.372 38.2722 35.9375 37.699 35.9375 37.1093C35.9375 36.6137 36.3036 35.9597 36.9066 35.8424C37.5599 35.7154 38.2343 35.731 38.8802 35.888C39.4528 36.0272 39.9003 36.3166 40.1778 36.8562C40.6852 37.8429 41.8964 38.2313 42.8831 37.7239C43.8697 37.2165 44.2582 36.0053 43.7508 35.0186C42.9771 33.5141 41.6 32.4142 39.9554 32.0145V31.2499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9197 58.0358C31.9197 56.9263 32.8191 56.0269 33.9286 56.0269H54.0179C55.1274 56.0269 56.0268 56.9263 56.0268 58.0358C56.0268 59.1452 55.1274 60.0447 54.0179 60.0447H33.9286C32.8191 60.0447 31.9197 59.1452 31.9197 58.0358Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9286 64.0625C32.8191 64.0625 31.9197 64.962 31.9197 66.0714C31.9197 67.1809 32.8191 68.0804 33.9286 68.0804H44.6429C45.7524 68.0804 46.6518 67.1809 46.6518 66.0714C46.6518 64.962 45.7524 64.0625 44.6429 64.0625H33.9286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2053 67.4107C21.2053 73.6978 26.3021 78.7946 32.5893 78.7946H70.7589C75.197 78.7946 78.7946 75.197 78.7946 70.7589V54.0178C78.7946 52.1685 77.2957 50.6696 75.4464 50.6696H66.741V29.9044C66.741 25.0941 62.841 21.2053 58.0357 21.2053H29.9107C25.1028 21.2053 21.2053 25.1028 21.2053 29.9107V67.4107ZM29.9107 25.2232C27.3218 25.2232 25.2232 27.3218 25.2232 29.9107V67.4107C25.2232 71.4789 28.5211 74.7768 32.5893 74.7768H63.7981C63.1145 73.5947 62.7232 72.2225 62.7232 70.7589V29.9044C62.7232 27.318 60.6269 25.2232 58.0357 25.2232H29.9107ZM66.741 70.7589V54.6875H74.7768V70.7589C74.7768 72.9778 72.9778 74.7768 70.7589 74.7768C68.54 74.7768 66.741 72.9778 66.741 70.7589Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_839",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32C31E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D9F1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_449_839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.2857,
    height: 64.2857,
    fill: "white",
    transform: "translate(17.8572 17.8572)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDonHang, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/DonHang.4ddd3de9.svg";
export { ForwardRef as ReactComponent };